import PropTypes from "prop-types"
import React from "react"
import TraySelector from "./../TraySelector/TraySelector"
import TraySwatch from "./components/TraySwatch"
import styled from "styled-components"

const defaultMask = {
  width: 600,
  height: 450,
  borderRadius: 70,
}

const traySelectorBaseProps = {
  mask: {
    width: 600,
    height: 600,
    borderRadius: "50%",
  },
  tray: {
    mask: defaultMask,
  },
  url: "",
}

const getMaskByTrayVariant = variant => {
  switch (variant.toLowerCase()) {
    case "round":
      return {
        width: 600,
        height: 600,
        borderRadius: "50%",
        custom: {
          left: "10px",
        },
      }

    case "trapezoid": {
      return {
        ...defaultMask,
        borderRadius: 20,
        custom: {
          clipPath:
            "polygon(25% 0%, 75% 0%, 100% 35%, 100% 100%, 0 100%, 0 35%)",
          background: "#0000004a",
          border: "none",
        },
      }
    }

    default:
      return defaultMask
  }
}

const SwatchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TrayDesigner = ({ trays, trayVariant }) => {
  const [currentTray, setTray] = React.useState(() => trays[0])

  return (
    <React.Fragment key={trayVariant}>
      <SwatchContainer>
        <h2 className="heading text-center">
          Select a color
        </h2>
        <TraySwatch
          currentTray={currentTray}
          onChange={setTray}
          trays={trays}
        />
        <br />
      </SwatchContainer>
      <TraySelector
        {...traySelectorBaseProps}
        mask={getMaskByTrayVariant(trayVariant)}
        image_url={currentTray}
        downloadTextButton={"Download"}
      />
    </React.Fragment>
  )
}

TrayDesigner.propTypes = {
  trays: PropTypes.arrayOf(PropTypes.string).isRequired,
  trayVariant: PropTypes.string.isRequired,
}

export default TrayDesigner
